<!-- Wrapper Body -->
<div class="wrapper-body">
  <div class="page-header d-flex align-items-center">
    <h3>Create Admin</h3>
  </div>
  <div class="content">
    <form id="createAdminForm" class="custom-form" autocomplete="off" [formGroup]="userForm" (ngSubmit)="submit()">
      
      <!-- Success and error messages -->
      <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
      <div *ngIf="failureMessage" class="alert alert-danger">{{ failureMessage }}</div>

      <!-- User Form Fields -->
      <div class="card light">
        <div class="row">
          <!-- First Name -->
          <div class="col-md-3">
            <input type="text" placeholder="First Name" formControlName="firstName"
            [ngClass]="{'border border-danger': f['firstName'].touched && f['firstName'].errors && f['firstName'].invalid}">
            <small class="text-danger" *ngIf="userForm.get('firstName')?.touched && userForm.get('firstName')?.errors?.['required'] && f['firstName'].invalid">
              First name is required.
            </small>
          </div>

          <!-- Last Name -->
          <div class="col-md-3">
            <input type="text" placeholder="Last Name" formControlName="lastName"
            [ngClass]="{'border border-danger': f['lastName'].touched && f['lastName'].errors && f['lastName'].invalid}">
            <small class="text-danger" *ngIf="userForm.get('lastName')?.touched && userForm.get('lastName')?.invalid">
              <span *ngIf="userForm.get('lastName')?.errors?.['required']">Last name is required.</span>
              <span *ngIf="userForm.get('lastName')?.errors?.['requiredNonWhitespace']">Last name cannot be just spaces.</span>
            </small>
          </div>

          <!-- Cell Number -->
          <div class="col-md-3">
            <p-inputMask mask="(999) 999-9999" placeholder="Cell Number" formControlName="mobileNo"
                                    [ngClass]="{'border border-danger': f['mobileNo'].touched && f['mobileNo'].errors && f['mobileNo'].invalid}"></p-inputMask>
          
            <small class="text-danger" *ngIf="userForm.get('mobileNo')?.touched || userForm.get('mobileNo')?.dirty">
                <!-- Display this when the field is required but not filled -->
                <span *ngIf="userForm.get('mobileNo')?.errors?.['required']">Mobile number is required.</span>
                
                <!-- Display this when the field does not meet the length requirement -->
                <span *ngIf="!userForm.get('mobileNo')?.errors?.['required'] && userForm.get('mobileNo')?.errors?.['invalidLength']">Mobile number must be 10 digits.</span>
            </small>
        </div>

          <!-- Email -->
          <div class="col-md-3">
            <input type="email" placeholder="Email" formControlName="email"
            [ngClass]="{'border border-danger': f['email'].touched && f['email'].errors && f['email'].invalid}">
            <small class="text-danger" *ngIf="userForm.get('email')?.touched || userForm.get('email')?.dirty">
                <span *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</span>
                <span *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</span>
                <span *ngIf="userForm.get('email')?.errors?.['pattern']">Email must be in a valid format (e.g., user@example.com).</span>
            </small>
        </div>

          <!-- Username -->
          <div class="col-md-3">
            <input type="text" placeholder="Username" formControlName="username" autocomplete="off" 
            [ngClass]="{'border border-danger': f['username'].touched && f['username'].errors && f['username'].invalid}">
            <small class="text-danger" *ngIf="userForm.get('username')?.touched && userForm.get('username')?.errors?.['required'] && f['username'].invalid">
              Username is required.
            </small>
          </div>

          <!-- Password -->
          <div class="col-md-3">
            <input type="password" placeholder="Create Password" formControlName="password" autocomplete="off"
            [ngClass]="{'border border-danger': f['password'].touched && f['password'].errors && f['password'].invalid}">
            <small class="text-danger" *ngIf="userForm.get('password')?.hasError('requiredPass') && userForm.get('password')?.invalid">
              Password is required.
          </small>
          
          <small class="text-danger" *ngIf="userForm.get('password')?.hasError('invalidPassLength') && userForm.get('password')?.invalid">
              Password must be at least 6 characters long.
          </small>
          </div>

          <!-- Confirm Password -->
          <div class="col-md-3">
            <input type="password" placeholder="Confirm Password" formControlName="confirmPassword" 
            [ngClass]="{'border border-danger': f['confirmPassword'].touched && f['confirmPassword'].errors && f['confirmPassword'].invalid}">
            <small class="text-danger" *ngIf="userForm.errors?.['passwordMismatch'] && userForm.get('confirmPassword')?.touched">
              Passwords must match.
          </small>
          </div>
        </div>
      </div>

      <!-- Form Submission Buttons -->
      <div class="row">
        <div class="col-12">
          <button type="submit" class="theme-button float-md-right">
            Create Admin
          </button>
          <button type="button" (click)="routerBack()" class="theme-button grey float-md-right mr-md-4">Back</button>
        </div>
      </div>
    </form>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>